import styled from 'styled-components'

export const ProfessionalNameFilterContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  div > p {
    margin-top: 5px;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  .spinner {
    margin: 10px 0;
    width: 30px;
    height: 30px;
    border-width: 5px;
  }
`